import { useMemo } from 'react';

import { useGetDxfSceneMapping } from '@frontend/api';

import { toAssignmentsMap } from '../session/mappingModel';
import type { MappingAssignments } from '../session/types';

/**
 * React Query boundary for the saved mapping. Maps the fetch into the
 * assignments shape the session loads — Viewer.tsx never sees DxfSceneMapping.
 *
 * `undefined` while the query has not resolved, so the caller leaves the session
 * alone until there is a real answer (including "no mapping row yet").
 */
export const useDxfSceneMapping = (
  partFileUuid: string | null | undefined,
): MappingAssignments | null | undefined => {
  const { data, isSuccess } = useGetDxfSceneMapping({ partFileUuid });

  return useMemo(() => {
    if (!isSuccess) {
      return undefined;
    }
    if (data === null) {
      return null;
    }
    return toAssignmentsMap(data.assignments);
  }, [isSuccess, data]);
};
